import { module } from 'angular';
import templateBuilderButtonDisplay from './builder/display.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/button/display.html', templateBuilderButtonDisplay);
});
